import template from './actionbar.html'

const actionbarComponent = (params = {}) => {
    return {
        actionIcon: params.actionIcon || 'back',
        secondActionIcon: params.secondActionIcon || null,
        async init(params) {
            this.$nextTick(() => {
                this.$el.innerHTML = template
            })
        },
        back() {
            if (params.actionTap) {
                params.actionTap.call(this)
            } else {
                this.app.goBack()
            }
        },
        secondAction() {
            if (!params.secondActionTap) return
            params.secondActionTap.call(this)
        }
    }
}

export { actionbarComponent }